angular.module('app.filters')
.filter('filterSelectedPractices', [
  '$log', function($log) {
    return function(selectedPractice, firmList) {
      var count, filteredFirms;
      filteredFirms = [];
      count = 0;
      firmList.forEach(function(firm, index, array) {
        firm.selected_jobs = [];
        firm.available_jobs.forEach(function(job, j_index, array) {
          count = 0;
          selectedPractice.forEach(function(sp, sp_index, array) {
            job.ref_practices.forEach(function(pa, index, array) {
              if (sp.practice_ID === pa.practice_ID && pa.job_practice_areas.isSelected && sp.lawyer_practices.isApproved && !sp.hasChild) {
                count++;
              }
            });
          });
          if (count > 0) {
            firm.selected_jobs.push(job);
          }
        });
        firm.available_jobs = angular.copy(firm.selected_jobs);
      });
      return firmList;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/selected-practices.js